import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { PayerEligibility } from "components/payers/eligibility/eligibility";
import { Requirements } from "components/payers/requirements/requirements";
import { IonicPageModule } from "ionic-angular";
import { IonicModule } from "ionic-angular/module";
import { CompanyResourcesPageModule } from "pages/company-resources/company-resources.module";
import { CommonComponentsModule } from "../../components/common/common-components.module";
import { ComponentsModule } from "../../components/components.module";
import { ConfigurableCardsModule } from "../../components/configurable/cards/configurable-cards.module";
import { BillingCodes } from "../../components/payers/billing-codes/billing-codes";
import { PayerEdi } from "../../components/payers/payer-edi/payer-edi";
import { ToolsModule } from "../../components/tools/tools.module";
import { NavigationModule } from "../../navigation/navigation.module";
import { CompanyPage } from "./company";
import { CompanyNavigation } from "./company-navigation/company-navigation";
import { ConfigureClearinghousePage } from "./clearinghouse-view/configure-clearinghouse/configure-clearinghouse";
import { CreateCompanyPage } from "./company-management/create-company/create-company";
import { CreateFacilityPage } from "./facilities-view/create-facility/create-facility";
import { ManageCareLevelsPage } from "./facilities-view/manage-care-levels/manage-care-levels";
import { CreatePayerPage } from "./payers-view/create-payer/create-payer";
import { WorkforceContactPage } from "./workforce/workforce-contact/workforce-contact";

@NgModule({
  declarations: [
    CompanyPage,
    CompanyNavigation,
    WorkforceContactPage,
    CreateCompanyPage,
    CreateFacilityPage,
    ManageCareLevelsPage,
    CreatePayerPage,
    ConfigureClearinghousePage,
    BillingCodes,
    PayerEdi,
    Requirements,
    PayerEligibility,
  ],
  imports: [
    IonicPageModule.forChild(CompanyPage),
    TranslateModule.forChild(),
    ConfigurableCardsModule,
    NavigationModule,
    ToolsModule,
    CommonComponentsModule,
    ComponentsModule,
    CompanyResourcesPageModule,
    IonicModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
  exports: [
    CompanyNavigation,
    CompanyPage,
    WorkforceContactPage,
    CreateCompanyPage,
    CreateFacilityPage,
    ManageCareLevelsPage,
    CreatePayerPage,
    ConfigureClearinghousePage,
  ],
  entryComponents: [
    WorkforceContactPage,
    // Pushed by CLASS from the Companies grid's + FAB — the factory MUST live here, exactly
    // like CreateFacilityPage / CreatePayerPage. (The modal this replaces was declared only in
    // the lazy CompanyManagementPageModule, which ModalController — a ROOT provider — cannot
    // see: the deployed build threw "No component factory found for AddCompanyModal".)
    CreateCompanyPage,
    CreateFacilityPage,
    ManageCareLevelsPage,
    CreatePayerPage,
    ConfigureClearinghousePage,
  ],
})
export class CompanyPageModule {}



// WEBPACK FOOTER //
// ./src/pages/company/company.module.ts